import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['type', 'select']

  connect() {
    this.questions = JSON.parse(this.data.get('questionsValue') || '[]')
    this.outcomes = JSON.parse(this.data.get('outcomesValue') || '[]')
  }

  change() {
    const type = this.typeTarget.value
    const select = this.selectTarget
    select.innerHTML = ''

    if (!type) {
      select.innerHTML = '<option>Select a result type first</option>'
      select.disabled = true
      select.classList.add('text-gray-400')
      return
    }

    const items = type === 'Question' ? this.questions : this.outcomes
    items.forEach((item) => {
      const opt = document.createElement('option')
      opt.value = item.id
      opt.textContent = item.text
      select.appendChild(opt)
    })

    select.disabled = false
    select.classList.remove('text-gray-400')
  }
}
